module.exports = __webpack_public_path__ + "img/providerQgis.8c287755.svg";